export default Object.freeze({
  UNSET: 0,
  ADDITIONAL_INFORMATION: 1,
  ACCEPT: 2,
  REJECT: 3,
  SUBMIT: 5,
  APPROVE_COMPLETE_PENDING_APPROVAL: 6,
  REJECT_COMPLETE_PENDING_APPROVAL: 7,
  PENDING_APROVAL: 8,
  RETURN_TO_PREVIOUS_STATUS: 9,
  DENY: 10,
  DOCUMENTS: 11,
});
